import { IoMdCheckmark } from 'react-icons/io';
import { LuMinus } from 'react-icons/lu';

import CopyCellRenderer from 'components/tables/AGGrid/CustomCells/CopyCellRenderer';
import ActionsButton from 'components/tables/AGGrid/ActionsButton';
import StatusCellRenderer from '@/components/v4/StatusCellRenderer';

import { carrierStatuses, getCarrierStatus } from './constants';

/**
 * Builds the AG Grid column definitions for the Carriers table.
 *
 * @param {object}   params
 * @param {function} params.onEditCarrier Called with the row data when the edit action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getCarriersTableColumns = ({ onEditCarrier }) => [
    {
        headerName: 'Carrier Name',
        field: 'name',
        cellRenderer: CopyCellRenderer,
        cellStyle: () => ({ width: '100%' }),
        flex: 1,
        minWidth: 150,
        // Default sort order (also restored when columns are reset).
        sort: 'asc',
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 140,
        sortable: true,
        filter: 'agSetColumnFilter',
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
        }),
        filterParams: {
            cellRenderer: (params) => {
                const isSelectedAll = params?.value === '(Select All)';
                const statusLookup = carrierStatuses[params.value];
                const displayName = statusLookup?.displayedName || '';
                return isSelectedAll ? '(Select All)' : displayName;
            },
        },
        cellRenderer: (params) => (
            <StatusCellRenderer
                value={getCarrierStatus(params.value)}
                statuses={carrierStatuses}
                fitText
            />
        ),
        valueFormatter: (params) =>
            carrierStatuses[params.value]?.displayedName ||
            carrierStatuses.default.displayedName,
    },
    {
        field: 'isActive',
        headerName: 'Active',
        width: 110,
        sortable: true,
        filter: 'agSetColumnFilter',
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
        }),
        cellRenderer: (params) => {
            return params.value ? (
                <IoMdCheckmark fontSize="large" />
            ) : (
                <LuMinus fontSize="large" />
            );
        },
        filterParams: {
            cellRenderer: (params) => {
                const isSelectedAll = params?.value === '(Select All)';
                const value = params.value ? (
                    <IoMdCheckmark fontSize="large" />
                ) : (
                    <LuMinus fontSize="large" />
                );
                return isSelectedAll ? '(Select All)' : value;
            },
        },
        valueFormatter: (params) => (params.value ? 'Active' : 'Inactive'),
    },
    {
        field: 'apiKey',
        headerName: 'API Key',
        minWidth: 180,
        hide: true,
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
        }),
        lockPosition: 'right',
        cellRenderer: (params) => {
            return (
                <ActionsButton
                    actions={[
                        {
                            label: 'Edit Carrier',
                            onClick: () => onEditCarrier(params.data),
                        },
                    ]}
                />
            );
        },
    },
];
